var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { "background-color": "#fff" } },
    [
      _c("van-nav-bar", {
        attrs: {
          "safe-area-inset-top": "",
          "left-arrow": "",
          title: "收货信息",
          fixed: "",
        },
        on: { "click-left": _vm.onClickLeft },
      }),
      _c("div", { staticClass: "box-content" }, [
        _c(
          "div",
          { staticClass: "div-conter" },
          [
            _c("van-overlay", { attrs: { show: _vm.isLoading } }, [
              _c(
                "div",
                { staticClass: "over-style" },
                [_c("van-loading", { attrs: { color: "#1989fa" } })],
                1
              ),
            ]),
            _c(
              "van-form",
              {
                ref: "shippingForm",
                attrs: { "validate-first": "" },
                on: {
                  failed: _vm.validationFailed,
                  submit: function ($event) {
                    return _vm.validationPassed(_vm.giftSettings)
                  },
                },
              },
              [
                _c("van-field", {
                  attrs: {
                    name: "shipmentReceiver",
                    placeholder: "请输入收货姓名",
                    label: "收货姓名",
                    rules: [{ required: true }],
                  },
                  model: {
                    value: _vm.shipmentReceiver,
                    callback: function ($$v) {
                      _vm.shipmentReceiver = $$v
                    },
                    expression: "shipmentReceiver",
                  },
                }),
                _c("van-field", {
                  attrs: {
                    name: "contactNumber",
                    type: "tel",
                    placeholder: "请输入联系方式",
                    label: "联系方式",
                    rules: [{ required: true }],
                  },
                  model: {
                    value: _vm.contactNumber,
                    callback: function ($$v) {
                      _vm.contactNumber = $$v
                    },
                    expression: "contactNumber",
                  },
                }),
                _c("van-field", {
                  attrs: {
                    name: "shipmentAddress",
                    placeholder: "请输入收货地址",
                    label: "收货地址",
                    rules: [{ required: true }],
                  },
                  model: {
                    value: _vm.shipmentAddress,
                    callback: function ($$v) {
                      _vm.shipmentAddress = $$v
                    },
                    expression: "shipmentAddress",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "submitBtn" }, [
        _c(
          "div",
          { staticClass: "submitBtn-d1" },
          [
            _c(
              "van-button",
              {
                attrs: {
                  disabled: !_vm.formIsValid,
                  round: "",
                  block: "",
                  type: "info",
                },
                on: { click: _vm.submit },
              },
              [_vm._v("提交")]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }